"use strict";

var _taggedTemplateLiteral = require("/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  border: none;\n  background: none;\n  height: 40px;\n  width: 40px;\n  display: flex;\n  justify-content: center;\n  border-radius: 100%;\n  outline: none;\n  &:hover {\n    outline: none;\n  }\n  &:active {\n    outline: none;\n  }\n  cursor: pointer;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

exports.CircleButton = styled_components_1.default.button(_templateObject());